import React, { useMemo, useRef } from 'react';
import { Form } from 'react-final-form';
import { useTranslation } from 'react-i18next';
import DwFormField from '@common/ui/formfield/DwFormField';
import Button from '@stone/ui/button/Button';
import '@stone/scss/components/authenticity-form/_authenticity-form.scss';
const authenticityForm = (props) => {
    const { t } = useTranslation();
    const formRef = useRef(null);
    const fieldDef = useMemo(() => {
        return {
            'authenticity-code': {
                htmlValue: '',
                mandatory: false,
                dynamicHtmlName: 'authenticity-code',
                valid: false,
                formType: 'formField',
                label: '',
                placeholder: t('authenticity.input.placeholder'),
                maxLength: 12,
                // error: fieldError,
                // pattern: '\\d+',
            },
        };
    }, []);
    return (React.createElement(Form, { target: "blank", onSubmit: (values) => {
            let acode = values['authenticity-code'];
            window.open(`https://www.certilogo.com/check/${acode}`, '_blank');
        }, validate: (values) => {
            let acode = values['authenticity-code'];
            if (!acode || acode.length != 12 || !/\d+/.test(acode)) {
                // setFieldError('missing');
                return {
                    'authenticity-code': t('authenticity.input.error'),
                };
            }
            return null;
        }, render: ({ handleSubmit }) => (React.createElement("form", { onSubmit: handleSubmit, ref: formRef },
            React.createElement("div", null,
                React.createElement("label", { className: "form-group__label", htmlFor: "authenticity-code" },
                    t('authenticity.input.code'),
                    React.createElement("span", { "aria-hidden": "true" }, "*"))),
            React.createElement("div", { className: "row" },
                React.createElement("div", { className: "col-24 col-lg-14 mb-32" },
                    React.createElement(DwFormField, { def: fieldDef, name: 'authenticity-code' })),
                React.createElement("div", { className: "col-24 col-lg-10 mb-40 mt-8" },
                    React.createElement(Button, { type: "submit", className: "full mt-4" }, t('authenticity.cta')))))) }));
};
export default authenticityForm;
